__turbopack_context__.v({
  "body": "legal-module__AUfgVG__body",
  "contactCard": "legal-module__AUfgVG__contactCard",
  "effective": "legal-module__AUfgVG__effective",
  "header": "legal-module__AUfgVG__header",
  "kicker": "legal-module__AUfgVG__kicker",
  "layout": "legal-module__AUfgVG__layout",
  "lead": "legal-module__AUfgVG__lead",
  "legalFadeUp": "legal-module__AUfgVG__legalFadeUp",
  "navLinks": "legal-module__AUfgVG__navLinks",
  "navSibling": "legal-module__AUfgVG__navSibling",
  "notice": "legal-module__AUfgVG__notice",
  "page": "legal-module__AUfgVG__page",
  "toc": "legal-module__AUfgVG__toc",
  "tocActive": "legal-module__AUfgVG__tocActive",
  "tocLabel": "legal-module__AUfgVG__tocLabel",
  "tocLink": "legal-module__AUfgVG__tocLink",
  "tocList": "legal-module__AUfgVG__tocList",
  "tocMobile": "legal-module__AUfgVG__tocMobile",
  "tocMobileList": "legal-module__AUfgVG__tocMobileList",
  "tocNum": "legal-module__AUfgVG__tocNum",
  "tocSummary": "legal-module__AUfgVG__tocSummary",
  "tocZone": "legal-module__AUfgVG__tocZone",
});
